export default __webpack_public_path__ + "static/media/sheena-headshot.fadc5bd4.png";